/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classnames from "classnames";
// reactstrap components
import { Row, Col,Table,FormGroup,Label,Input,Button } from "reactstrap";
import CustomControls from './CustomControls.js'
import { options } from "headroom.js";

class Index extends React.Component {
  state = {
    circledNavPills: 1,
  };
  toggleNavs = (e, state, index) => {
    e.preventDefault();
    this.setState({
      [state]: index
    });
  };
  componentDidMount(){
  }
  
  render() {
    const product = this.props.product;
    const category = this.props.category;
    var options = this.props.options;
    var codeId
    if(product){
      codeId = (product.shortcode)
    }
    var imgUrl;
    if(product){      
      if(product.imageurl){
        imgUrl = product.imageurl;
        if(imgUrl.includes("dropbox.com")){
          imgUrl = imgUrl.replace("dl=0","raw=1")
        }
      }
      else{
        imgUrl = require("assets/img/theme/product-placeholder.jpg")
      }
      return (
        <Row className="mt-4">
          <Col lg="4" className="text-center">
            <img
              alt="..."
              className="img-fluid"
              src={imgUrl}              
              style={{ width: "430px", height: 'auto',  margin:'auto' }}
            />
          </Col>
          <Col lg="8">
            <h5 className="mb-4"> Catalogue - {category.label}</h5>
            <div className="product-title">
              <h4 className="mb-0">{product.category} - {product.shortcode}</h4>
              <p className="mb-0">${(product.price*1).toFixed(2)}</p>
            </div>
            {/* <p>
              {product.description}
            </p> */}
            <div style={{overflow:'auto'}}>
              <Table className="product-options mb-0">
                <thead>
                  <tr>
                    <th>Color</th>
                    <th className=""><span className="ml-2">Size</span></th>
                  </tr>
                </thead>
              </Table>
              <Table className="product-options mb-0">
                <thead>
                  {/* <tr>
                    <th width="20%" width="140">Color</th>
                    <th width="80%" className="">Size</th>
                  </tr> */}
                </thead>
                <tbody>
                  {
                    this.props.colournames.map((color,index)=>(
                      <tr key={index}>
                        <td style={{width: '1%',whiteSpace: 'nowrap'}}>
                          <p style={{marginTop:'14.5px', marginRight:'30px'}}>{color}</p>
                        </td>
                        {
                          this.props.sizenames.map((size)=>(  
                            <>
                              {!this.props.checkDisable(codeId, color, size) && 
                                <td width="120px">      
                                  <div key={color+"_"+size} className="">                                
                                    <Input type="number" min="0" key={index} value={(options&&options[category.key]&&options[category.key][codeId]&& options[category.key][codeId][color])?options[category.key][codeId][color][size]:''} 
                                      onChange={
                                        (e)=>{
                                          this.props.changeOptions(color, size, e.target.value, null)
                                        }
                                      }
                                    >
                                    </Input>
                                    <label>{size}</label>
                                  </div> 
                                </td>  
                              } 
                            </>
                          ))
                        }   
                        <td style={{minWidth:50}}></td>  
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
            </div>
            {/* <Table className="product-options mb-0">
              <thead>
                <tr>
                  <th width="40%" className="pb-0">
                    <Label for="exampleSelectMulti">Select Colour</Label>
                  </th>
                  <th width="40%" className="pb-0">
                    <Label for="exampleSelectMulti">Select Size</Label>
                  </th>
                  <th width="15%" className="pb-0">
                    <Label for="exampleSelectMulti">Qty</Label>
                  </th>
                  <th width="5%" className="pb-0">
                  </th>
                </tr>
              </thead>
              <tbody>
                {
                  this.props.options.map((option, index)=>(<tr>
                    <td>
                        <Input type="select" name="colour" onChange={(e)=>this.props.changeOptions(index, 'colour', e.target.value)}>
                          {
                            this.props.colournames.map((item)=>(                                
                              <option value={item}>{item}</option>
                            ))
                          }
                        </Input>
                    </td>
                    <td>  
                        <Input type="select" name="size" onChange={(e)=>this.props.changeOptions(index, 'size', e.target.value)}>
                          {
                            this.props.sizenames.map((item)=>(                                
                              <option value={item}>{item}</option>
                            ))
                          }
                        </Input>
                    </td>
                    <td>  
                        <Input type="text" name="qty" onChange={(e)=>this.props.changeOptions(index, 'qty', e.target.value)}>
                        </Input>
                    </td>
                    <td>  
                      {this.props.options.length>1 &&
                      }
                    </td>
                  </tr>
                  ))
                }                    
              </tbody>
            </Table> */}
          </Col>
        </Row>
      );
    }
    else{
      return (
        <></>
      )
    }
  }
}

export default Index;
